import { getGraphHeaders } from '@/utils/getGraphHeaders';
import { logWarning } from '@/utils/miscUtils';
import { BffBrandType } from '@/types/generated';

export const getBffNearByFacilitiesByLocation = async (
	brand: BffBrandType,
	latitude: number,
	longitude: number,
	url: string,
	appName: string,
	appVersion: string,
	additionalParams?: {
		// SonarQube rule: Reduce the number of parameters
		radiusMiles?: number;
		maxItems?: number;
		fetchAllIfNoResults?: boolean;
	}
) => {
	try {
		if (!brand) {
			return null;
		}

		if (!latitude || !longitude) {
			return Promise.reject(`Invalid coordinates of latitude: ${latitude} and longitude: ${longitude}`);
		}
		const { getGraphQLClient } = await import(
			/* webpackChunkName:"getGraphQLClient" */ '../graphql/getGraphQLClient'
		);
		return await getGraphQLClient(url).bffNearByFacilitiesByLocation(
			{
				brand,
				latitude,
				longitude,
				fetchAllIfNoResults: !!additionalParams?.fetchAllIfNoResults,
				radiusMiles: additionalParams?.radiusMiles ?? 50,
				maxItems: additionalParams?.maxItems ?? 1000,
			},
			getGraphHeaders(appName, appVersion)
		);
	} catch (err) {
		logWarning(`Could not find any near by facilities data for: ${brand}`);
	}
};
